import base from "../baseurl";
import token from "../getTk";

const Show = async (Uuid) => {
  const tokenA = token.get();

  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });

  const status = await api
    .post("companies/show", { json: { companyUuid: Uuid } })
    .json();
  console.log(status);
  return status.data.company;
};

export default Show;
